import { ProductInterface } from '@pylot-data/fwrdschema'
import { ProductStockStatus } from '@pylot-data/enums/ProductStockStatus'
/**
 * https://schema.org/ItemAvailability - has more statuses, but we handle only two
 *
 * @param stockStatus
 */
export const getProductAvailability = (
    product?: ProductInterface | null
): string => {
    if (product && product.stock_status === ProductStockStatus.InStock)
        return 'InStock'
    return 'OutOfStock'
}
